<script>
    import {createEventDispatcher} from 'svelte';

    import Modal from "../../UI/Modal.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Icono from "../../UI/Icono.svelte";
    import InputNumerico from "../../UI/InputNumerico.svelte";
    import Boton from "../../UI/Boton.svelte";
    import storeMotivos from '../../../Stores/motivos-store';

    export let marcaje = null;

    const dispatch = createEventDispatcher();

    let [hora, minutos] = marcaje.hora.split(':').map(x => parseInt(x, 10));
    let motivo = marcaje.motivo ? marcaje.motivo.nombre : '';
    let observaciones = '';

    $: valido = hora >= 0 && hora < 32 && minutos >= 0 && minutos < 60 && observaciones.trim() && motivo;

    const guardar = () => dispatch('guardado', {
        hora: `${hora.toString(10).padStart(2, '0')}:${minutos.toString(10).padStart(2, '0')}`,
        motivo,
        observaciones
    });
</script>

<style>
    .formulario {
        display: grid;
        grid-template-columns: max-content 1fr;
        grid-template-rows: max-content 1fr;
        grid-gap: var(--padding-global);
    }

    .tipo {
        grid-column: 1 / 3;
        grid-row: 1;
    }

    .subtitulo {
        grid-column: 1;
        grid-row: 2;
    }

    .campos {
        display: flex;
        margin-top: calc(var(--padding-global) / 2);
    }

    .campo:not(:last-child) {
        margin-right: var(--padding-global);
    }

    .motivo {
        grid-column: 2;
        grid-row: 2;
    }

    textarea {
        width: 100%;
        border: 1px solid var(--verde);
        margin-top: calc(var(--padding-global) / 2);
        height: 6.8em;
        font-size: 1em;
        font-family: inherit;
        padding: calc(var(--padding-global) / 2);
    }

    .tipos {
        margin-top: calc(var(--padding-global) / 2);
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        grid-template-columns: 1fr 1fr;
    }

    .tipos label {
        padding: calc(var(--padding-global) / 2);
        text-align: center;
        color: #fff;
        border-radius: var(--radio-global);
        transition: .3s;
        margin-bottom: var(--padding-global);
        max-width: calc(33.3333 - var(--padding-global) / 2);
    }

    .tipos label:first-child,
    .tipos label:nth-child(2) {
        width: calc(50% - var(--padding-global) / 2);
    }

    .actividad {
        background: var(--verde);
        transition: .5s;
        opacity: .7;
    }

    .actividad.activo {
        transform: scale(1.1);
        opacity: 1;
    }

    .ausencia {
        background: var(--acentos);
        transition: .5s;
        opacity: .7;
    }

    .ausencia.activo {
        transform: scale(1.1);
        opacity: 1;
    }

    input[type="radio"] {
        display: none;
    }
</style>

<Modal on:cancel title="Corrección de incidencia en marcaje" estrecho>
    <div class="formulario">
        <div class="tipo">
            <Subtitulo>Tipo de marcaje</Subtitulo>

            <div class="tipos">
                {#each $storeMotivos.listado as tipoDeMarcaje}
                    <label class={tipoDeMarcaje.tipo.toLowerCase()}
                           class:activo={tipoDeMarcaje.nombre === motivo}>
                        <input type="radio" bind:group={motivo} value={tipoDeMarcaje.nombre}>

                        <Icono svg={tipoDeMarcaje.icono} externo
                               tamano={30}/>
                        <div>{tipoDeMarcaje.nombre}</div>
                    </label>
                {/each}
            </div>
        </div>

        <div class="subtitulo">
            <Subtitulo icono="access_time">Hora</Subtitulo>

            <div class="campos">
                <div class="campo">
                    <InputNumerico valor={hora} on:cambio={e => hora = e.detail} min="0" max="32"/>
                </div>
                <div class="campo">
                    <InputNumerico valor={minutos} on:cambio={e => minutos = e.detail} min="0"
                                   max="59"/>
                </div>
            </div>
        </div>

        <div class="motivo">
            <Subtitulo icono="bug_report"><label for="motivo">Motivo</label></Subtitulo>
            <textarea placeholder="Por favor, indique el motivo de la incidencia" id="motivo"
                      bind:value={observaciones}></textarea>
        </div>
    </div>

    <div slot="footer">
        <Boton on:click={guardar} disabled={!valido} tipo="ok">
            <Icono margen tamano={16}>check</Icono>
            Guardar
        </Boton>

        <Boton on:click={() => dispatch('cancel')}>
            <Icono margen tamano={16}>close</Icono>
            Cancelar
        </Boton>
    </div>
</Modal>